import TextAnalysisBubbleDetails from "../components/TextAnalysisBubbleDetails";

export default function TextPage() {
  return <TextAnalysisBubbleDetails />;
}
